<template>
    <div class="bg-white bg-opacity-90 backdrop-blur-lg rounded-lg shadow-lg w-80 sm:w-96 max-h-96 overflow-y-auto">
      <div class="p-4 border-b flex justify-between items-center">
        <h2 class="text-lg font-bold text-gray-800">Notifications</h2>
        <button @click="$emit('close')" class="sm:hidden text-gray-500 hover:text-gray-700">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>
      <div v-if="notifications.length === 0" class="p-4 text-center text-gray-500">
        No notifications
      </div>
      <div v-for="notification in notifications" :key="notification._id" class="p-4 border-b" :class="{ 'bg-gray-100': notification.read }">
        <p class="text-sm text-gray-800">{{ notification.message }}</p>
        <p class="text-xs text-gray-500 mt-1">{{ new Date(notification.timestamp).toLocaleString() }}</p>
        <button v-if="!notification.read" @click="$emit('mark-read', notification._id)" class="text-blue-500 text-xs mt-2 hover:underline">
          Mark as Read
        </button>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: ['notifications'],
  };
  </script>